
    import './styles.scoped.css';
    export default {
  "button-trigger": "awsui_button-trigger_18eso_3vu11_17",
  "arrow": "awsui_arrow_18eso_3vu11_17",
  "in-filtering-token-root": "awsui_in-filtering-token-root_18eso_3vu11_77",
  "in-filtering-token-nested": "awsui_in-filtering-token-nested_18eso_3vu11_77",
  "has-caret": "awsui_has-caret_18eso_3vu11_113",
  "placeholder": "awsui_placeholder_18eso_3vu11_116",
  "pressed": "awsui_pressed_18eso_3vu11_132",
  "disabled": "awsui_disabled_18eso_3vu11_138",
  "in-filtering-token": "awsui_in-filtering-token_18eso_3vu11_77",
  "readonly": "awsui_readonly_18eso_3vu11_159",
  "compact": "awsui_compact_18eso_3vu11_171",
  "invalid": "awsui_invalid_18eso_3vu11_182",
  "warning": "awsui_warning_18eso_3vu11_191",
  "custom-option": "awsui_custom-option_18eso_3vu11_206",
  "inline-tokens": "awsui_inline-tokens_18eso_3vu11_211",
  "grouped": "awsui_grouped_18eso_3vu11_253",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_18eso_3vu11_259",
  "grouped-in-error": "awsui_grouped-in-error_18eso_3vu11_266",
  "grouped-in-warning": "awsui_grouped-in-warning_18eso_3vu11_271",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_18eso_3vu11_286",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_18eso_3vu11_310",
  "grouped-vertical-first": "awsui_grouped-vertical-first_18eso_3vu11_337",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_18eso_3vu11_364",
  "grouped-vertical-last": "awsui_grouped-vertical-last_18eso_3vu11_388",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_18eso_3vu11_415",
  "grouped-vertical-only": "awsui_grouped-vertical-only_18eso_3vu11_415",
  "grouped-with-action": "awsui_grouped-with-action_18eso_3vu11_445",
  "grouped-validation": "awsui_grouped-validation_18eso_3vu11_455"
};
  